// Alleen-lezen-modus: verbergt (naast de CSS-heuristiek in index.css) knoppen op tekst — "Opslaan", "Nieuwe …", "Verwijderen", …
// Werkt op de module-inhoud én op dialogen/menu's (portals). Opt-out per knop: data-rechten="lezen".
const WOORDEN = /^(opslaan|bewaar|bewaren|toevoegen|voeg toe|verwijder(en)?\b(?! filter)|bewerk(en)?\b|aanmaken|maak aan|nieuw(e)?\b|goedkeuren|keur goed|afwijzen|afkeuren|bijwerken|wijzig(en)?\b|publiceer|publiceren|upload(en)?\b|importeer|importeren|toewijzen|wijs toe|archiveer|archiveren|herstel(len)?\b|activeer|activeren|deactiveer|deactiveren|verwerk(en)?\b|markeer|koppel(en)?\b|ontkoppel(en)?\b|genereer|genereren|instellen\b|verstuur melding|corrigeer|corrigeren|resetten|reset wachtwoord)/i;
const SCOPE = "main .module-inhoud, [role='dialog'], [role='alertdialog'], [role='menu'], [data-radix-popper-content-wrapper]";
const KLASSE = "rechten-verborgen";
let observer = null;
let raf = 0;

function scan() {
  raf = 0;
  document.querySelectorAll(SCOPE).forEach((root) => {
    root.querySelectorAll("button, [role='menuitem']").forEach((el) => {
      if (el.getAttribute("data-rechten") === "lezen" || el.getAttribute("role") === "tab") return;
      const tekst = (el.textContent || "").trim().replace(/\s+/g, " ");
      if ((el.getAttribute("type") === "submit" && el.closest("form")) || (tekst && tekst.length < 40 && WOORDEN.test(tekst))) {
        el.classList.add(KLASSE);
      }
    });
  });
}

function plan() {
  if (!raf) raf = requestAnimationFrame(scan);
}

export function startAlleenLezenScanner() {
  if (observer) return;
  observer = new MutationObserver(plan);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  plan();
}

export function stopAlleenLezenScanner() {
  if (observer) { observer.disconnect(); observer = null; }
  if (raf) { cancelAnimationFrame(raf); raf = 0; }
  document.querySelectorAll(`.${KLASSE}`).forEach((el) => el.classList.remove(KLASSE));
}
